import React from "react"
import { useLocation } from '@reach/router'

import TalkSalesModal from 'components/modals/TalkSales/TalkSales'

const Modals = () => {
  const locationHash = useLocation().hash

  return (
    locationHash === "#form=talk-sales"
      ? <TalkSalesModal isOpen={true} /> : null
  )
}

export default Modals
